(function () {

    'use strict';

    function initAuth0Provider(angularAuth0Provider, luminaEnv) {
        angularAuth0Provider.init({
            clientID:       luminaEnv.auth0.clientId,
            domain:         luminaEnv.auth0.domain,
            redirectUri:    luminaEnv.appUrl + '/loginCallback',
            scope:          luminaEnv.auth0.scope,
            responseType:   'token'
        });
    };

    module.exports = function(angularAuth0Provider, luminaEnv) {
        var authService = require('./auth.js');

        this.init = function() {
            initAuth0Provider(angularAuth0Provider, luminaEnv);
        }

        // Return the auth service
        this.$get = ['$rootScope', '$q', '$state', '$window', '$document', '$http', '$cookies', '$location', '$timeout', 'authManager', 'jwtHelper', 'angularAuth0', 'luminaProfile', 'returnUrlSanitise',
            function authServiceFactory($rootScope, $q, $state, $window, $document, $http, $cookies, $location, $timeout, authManager, jwtHelper, auth0, luminaProfile, returnUrlSanitise) {
                return new authService($rootScope, $q, $state, $window, $document, $http, $cookies, $location, $timeout, authManager, jwtHelper, auth0, luminaEnv, luminaProfile, returnUrlSanitise);
            }
        ];
    };

})();
